import './StatusBar.scss';

import React from 'react';
import classnames from 'classnames';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx } = cxHelpers('StatusBar');

const STATUSES = {
  late: 'timecard_modal_v3.statuses.late',
  in_progress: 'timecard_modal_v3.statuses.in_progress',
  on_break: 'timecard_modal_v3.statuses.on_break',
};

const COLORS = {
  late: 'orange100',
  in_progress: 'green100',
  on_break: 'blue100',
};

const StatusBar = ({ isMobile, status }) => (
  <Box
    pv={3}
    mt={-1}
    w="100%"
    tcenter
    bgcolor={COLORS[status]}
    className={classnames(cx(), {
      desktop: !isMobile,
    })}
  >
    <Text color="mono900" variant="heading4">
      {toI18n(STATUSES[status])}
    </Text>
  </Box>
);

StatusBar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
};

export default StatusBar;
